import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewNovSap = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'nov_sap',
        name: 'NOV_SAP',
        component: ViewNovSap,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router